// src/modules/app-views/services/pages/Init/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { ImportOutlined } from '@ant-design/icons';
import { dropdownDivider, dropdownParameters } from 'layouts/Pages/PageHeader/dropdownMenus';
import { showDataImportModal } from 'components/core/migration/DataImportModal';

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const servicesInitMenuButton = () => {
  return {
    action: 'dropdownMenu',
    dropdownItems: [
      dropdownParameters,
      dropdownDivider,

      // Data Import - import services from CSV/XLS/JSON
      {
        key: 'importData',
        label: 'data_import',
        icon: <ImportOutlined />,
        onClick: ({ refresh }) => {
          showDataImportModal({
            targetModule: 'services',
            moduleLabel: 'Serviços',
            onSuccess: () => refresh?.(),
          });
        },
      },
    ],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default servicesInitMenuButton;
